import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Divider"
          text="Keep a margin of 16px between the divider and any adjacent components, both above and below. The divider must span 100% width of the parent container."
          code={code.divider}
        >
          <hr class="c-divider" />
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  /*
  divider: `<hr class="c-divider" />
`,
*/
}
